module.exports = __webpack_public_path__ + "static/media/right-white.992f1aca.svg";